// extracted by css-extract-rspack-plugin
module.exports =  {"solution-container":"StudentAnswer-Tehj__solution-container"};